/**
 * @generated SignedSource<<696d20464efea57921d928991012ecae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAuthModalFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WalletSelectorFragment">;
  readonly " $fragmentType": "useAuthModalFragment";
};
export type useAuthModalFragment$key = {
  readonly " $data"?: useAuthModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAuthModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuthModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WalletSelectorFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "040c71e2c84d2c4c2942959e1b47cd4c";

export default node;
